import { render, staticRenderFns } from "./unusualOrderManage.vue?vue&type=template&id=b33b554e&scoped=true&"
import script from "./unusualOrderManage.vue?vue&type=script&lang=js&"
export * from "./unusualOrderManage.vue?vue&type=script&lang=js&"
import style0 from "./unusualOrderManage.vue?vue&type=style&index=0&id=b33b554e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33b554e",
  null
  
)

export default component.exports